module.exports = __webpack_public_path__ + "img/img1.55e4e0bf.png";